module.exports = __webpack_public_path__ + "img/DashboardFinal.909773fb.png";